module.exports = __webpack_public_path__ + "ddb8362e333c8f3225da9d578d00c14c.png";